import OrdersTable from 'components/ordersPage'
import { RootState } from 'dataStore/state'
import { buildAdminOrdersListQueryFromState } from 'handlers/buildAdminOrdersListParams'
import { useActions } from 'hooks/useActions'
import { FC, useEffect } from 'react'
import { useSelector } from 'react-redux'

const Statistics: FC = () => {
  const { getAdminOrdersList, getDashboardSummary, getAllOrderStatus } =
    useActions()
  const { pagination, filter, sortBy, sortOrder } = useSelector(
    (state: RootState) => state.orders
  )

  /**
   * Query для сводки (без пагинации).
   */
  const buildSummaryQuery = () => ({
    pizzeria_id: filter?.pizzeria_id,
    status_id: filter?.status_id,
    payment_type: filter?.paymentType,
    payment_status: filter?.paymentStatus,
  })

  /**
   * Query для списка заказов.
   */
  const buildListQuery = () =>
    buildAdminOrdersListQueryFromState({
      filter,
      pagination,
      sortBy,
      sortOrder,
    })

  useEffect(() => {
    getAllOrderStatus()
  }, [])

  useEffect(() => {
    getAdminOrdersList(buildListQuery())
    getDashboardSummary(buildSummaryQuery())
  }, [
    pagination.page,
    pagination.rowsPerPage,
    filter?.pizzeria_id,
    filter?.status_id,
    filter?.paymentType,
    filter?.paymentStatus,
    sortBy,
    sortOrder,
  ])

  // Автообновление списка и сводки раз в 2 минуты
  useEffect(() => {
    const timer = setTimeout(() => {
      getAdminOrdersList(buildListQuery())
      getDashboardSummary(buildSummaryQuery())
    }, 120000)
    return () => {
      clearTimeout(timer)
    }
  }, [
    pagination.page,
    pagination.rowsPerPage,
    filter?.pizzeria_id,
    filter?.status_id,
    filter?.paymentType,
    filter?.paymentStatus,
    sortBy,
    sortOrder,
  ])

  return (
    <div>
      <OrdersTable />
    </div>
  )
}

export default Statistics
